// extracted by mini-css-extract-plugin
export default {"container":"adminLayout_container__V+B7b","form":"adminLayout_form__-n-f2","input":"adminLayout_input__XPij9","submitButton":"adminLayout_submitButton__jSPvL"};